var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkCustom)?_c('external-link',{attrs:{"label":_vm.linkCustom,"value":_vm.linkCustom}}):(_vm.linkDefault)?_c('external-link',{attrs:{"label":_vm.linkDefault,"value":_vm.linkDefault}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }